import CardLogin from 'app/components/Layouts/CardLogin';
import { Box, Button, Typography } from '@mui/material';
import { descText, infoText } from './LinkConfirm.sx';
import React from 'react';
import useLinkConfirm from 'app/pages/Authorization/LinkConfirm/useLinkConfirm';

const LinkConfirm = () => {
  const { t, handleConfirm } = useLinkConfirm();

  return (
    <CardLogin>
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
        <Box>
          <Typography sx={infoText}>{t('recovery.confirm')}</Typography>
          <Typography sx={descText}>{t('recovery.confirmDesc')}</Typography>
          <Typography sx={descText}>{t('recovery.confirmDesc2')}</Typography>
        </Box>
        <Button type={'button'} onClick={handleConfirm}>
          {t('recovery.confirmBtn')}
        </Button>
      </Box>
    </CardLogin>
  );
};

export default LinkConfirm;
